import React, { useEffect, useState } from "react";
import Wrapper from "./Loginpage.styled";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../Components/Button/Button";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import FormControl from "../../../Components/FormControl/FormControl";
import Gobackbuton from "../../../Components/Gobackbutton/Gobackbuton";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  setLoading,
  setLoadingFalse,
} from "../../../Store/Reducers/Auth/actions";
import CountrySelectForm from "../../../Components/CountrySelectForm/CountrySelectForm";
import Error from "../../../Components/Error";
import Spinner from "../../../Components/Spinner";

function Loginpage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state?.Auth);
  const [formValue, setFormValue] = useState("");
  const [showNumForm, setShowNumForm] = useState(true);
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({
    label: "Israel",
    value: "+972",
  });
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  // select options
  const options = [
    {
      label: "RU + 7",
      value: "ru",
      default: true,
    },
    {
      label: "BD + 7",
      value: "bd",
      default: false,
    },
    {
      label: "PK + 7",
      value: "pk",
      default: false,
    },
  ];
  // animation phone number field
  const animate1 = {
    x: [-100, 0],
    opacity: [0, 1],
    transition: { duration: 1 },
  };

  // animation email input field
  const animate2 = {
    y: [100, 0],
    opacity: [0, 1],
    transition: { duration: 1 },
  };

  const handleSubmit = () => {
    let payload = {
      data,
      success: (results) => {
        // navigate("/dashboard");
      },
      fail: (error) => {
        setError(error?.msg);
      },
    };
    dispatch(login(payload));
  };

  const setPhone = (e) => {
    if (!isNaN(e.target.value)) {
      setFormValue(e.target.value);
    }
  };

  useEffect(() => {
    dispatch(setLoading(false));
  }, []);

  return (
    <Wrapper>
      {/* <div className="go-back-button">
        <Gobackbuton primaryIcon={true} />
      </div> */}
      <div className="top-row">
        <div className="title">
          <h1>Log In</h1>
        </div>
        <motion.div className="buttonGroups" animate={{ y: [-20, 0] }}>
          <Button
            text="Phone Number"
            primary={showNumForm ? true : false}
            textcolor={showNumForm ? true : false}
            onClick={() => setShowNumForm(true)}
          />
          <Button
            text="Email"
            primary={showNumForm ? false : true}
            textcolor={showNumForm ? false : true}
            onClick={() => setShowNumForm(false)}
          />
        </motion.div>
        <div className="form">
          {showNumForm ? (
            <motion.div className="form-control-mobile" animate={animate1}>
              <FormControl labelValue="Phone Number" htmlFor="PhoneNumber" />
              <div className="row ">
                <div className="col1 col">
                  <CountrySelectForm setSelectedCountry={setSelectedCountry} />
                </div>
                <div className="col2 col  mx-0 px-1">
                  <FormControl
                    style={{ border: "none", marginTop: "-10px" }}
                    input={true}
                    inputValue={formValue}
                    type="text"
                    htmlFor="PhoneNumber"
                    maxLength="13"
                    onChange={(e) => setPhone(e)}
                  />
                </div>
              </div>
              <div>{error ? <Error text={error} /> : " "}</div>
            </motion.div>
          ) : (
            // <motion.div className="form-control-mobile" animate={animate1}>
            //   <FormControl labelValue="Phone Number" htmlFor="PhoneNumber" />
            //   <div className="row">
            //     <div className="col1">
            //       <FormControl
            //         select={true}
            //         options={options}
            //         dropdownIcon={
            //           <Icon
            //             icon="ant-design:caret-down-filled"
            //             color="var(--app-color-dark)"
            //           />
            //         }
            //       />
            //     </div>
            //     <div className="col2">
            //       <FormControl
            //         input={true}
            //         inputValue={formValue}
            //         type="text"
            //         htmlFor="PhoneNumber"
            //         onChange={(e) => setFormValue(e.target.value)}
            //       />
            //     </div>
            //   </div>
            // </motion.div>
            <div className="form-control-email">
              <motion.div className="row" animate={animate2}>
                <FormControl
                  labelValue="Email"
                  htmlFor="email"
                  input={true}
                  inputValue={data.email}
                  type="text"
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  placeholder="email.example@gmail.com"
                />
              </motion.div>
              <motion.div className="row" animate={animate2}>
                <div className="password">
                  <FormControl
                    labelValue="Password"
                    htmlFor="password"
                    input={true}
                    inputValue={data.password}
                    type={showPass ? "text" : "password"}
                    placeholder="Enter password"
                    passwordType={true}
                    onChange={(e) =>
                      setData({ ...data, password: e.target.value })
                    }
                    onClick={() => setShowPass(!showPass)}
                  />
                </div>
              </motion.div>
              {error && (
                <motion.div className="row" animate={animate2}>
                  <div className="custom_error_for_all_fields">
                    <span className="">{error}</span>
                  </div>
                </motion.div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="bottom-row">
        {loading ? (
          <div className="">
            <Spinner />
          </div>
        ) : (
          <div className="form-submit">
            <Button
              text={showNumForm ? "Continue" : "Log in"}
              primary={true}
              textcolor={true}
              onClick={handleSubmit}
              width={"100%"}
            />
          </div>
        )}

        <div className="forgot-pass-text">
          <p>
            Trouble signing in?
            <Link to="resetpassword">Contact Us</Link>
          </p>
        </div>
      </div>
    </Wrapper>
  );
}

export default Loginpage;
